/**
 * The calm call waveform (docs/ux/artboards/call/ios-call.html): centred bars that breathe with
 * a transform-only scaleY, still under reduced motion. Deterministic heights (no audio meter: the
 * state line says what is happening; the bars only show that it is live).
 */
export function CallWave({
  mode,
  bars = 24,
}: {
  mode: 'listen' | 'speak' | 'still'
  bars?: number
}) {
  const w = 4
  const gap = 3
  const h = 24
  const width = bars * (w + gap) - gap
  return (
    <svg
      className={`call-wave is-${mode}`}
      width={width}
      height={h}
      viewBox={`0 0 ${width} ${h}`}
      aria-hidden="true"
      focusable="false"
    >
      {shape(bars, w, gap, h).map((b) => (
        <rect
          key={b.x}
          x={b.x}
          y={(h - b.h) / 2}
          width={w}
          height={b.h}
          rx={2}
          style={{ animationDelay: `${b.delay}ms` }}
        />
      ))}
    </svg>
  )
}

/** Bar positions and heights: a smooth, uneven envelope, taller in the middle, never flat. */
function shape(bars: number, w: number, gap: number, h: number) {
  return Array.from({ length: bars }, (_, i) => {
    const env = 0.35 + 0.65 * Math.sin(((i + 0.5) / bars) * Math.PI)
    const jitter = 0.55 + 0.45 * Math.abs(Math.sin(i * 2.17 + 1.3))
    return {
      x: i * (w + gap),
      h: Math.max(3, Math.round(h * env * jitter)),
      delay: -((i * 137) % 1200),
    }
  })
}
